import React from 'react';
import RCSlider from 'rc-slider';

const Range = RCSlider.createSliderWithTooltip(RCSlider.Range);

export default class Slider extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: []
        };
    }

    handleChange(value) {
        this.setState({value}, () => {
            this.props.handleChange(this.state.value);
        });
    }

    componentDidMount() {
        if (this.props.value) {
            this.setState({value: this.props.value});
        } else {
            this.setState({value: [this.props.item.min, this.props.item.max]});
        }
    }

    componentWillReceiveProps(newProps) {
        this.setState({value: newProps.value});
    }

    label_height(value) {
        if (value) {
            let centimeters = value;
            let meters = Math.floor(value / 100);
            centimeters %= 100;

            let inches = (value * 0.393700787).toFixed(0);
            let feet = Math.floor(inches / 12);
            inches %= 12;

            return `${meters}m ${centimeters}cm (${feet}ft ${inches}in)`;
        }
        return '';
    }

    label_weight(value) {
        if (value) {
            let lbs = (value * 2.20462262).toFixed(0);

            let stoneslb = value;
            let stones = Math.floor(value / 6.350);
            stoneslb %= 6.350;
            stoneslb = Math.floor(stoneslb / 0.4536);

            return `${lbs}lbs (${stones}st ${stoneslb}lbs)`;
        }
        return '';
    }

    label() {
        let value = this.state.value ? this.state.value : [this.props.item.min, this.props.item.max];
        if (this[`label_${this.props.item.name}`] && typeof this[`label_${this.props.item.name}`] === 'function') {
            value = value.map((item) => {
                return this[`label_${this.props.item.name}`](item);
            });
        }
        let values = value instanceof Array ? value.join('-') : '';
        return `${this.props.item.prefix}${values}`;
    }

    render() {
        return (
            <div className="form-group">
                <p className="slider-label">{this.label()}</p>
                <Range min={this.props.item.min} max={this.props.item.max} tipFormatter={value => `${this.props.item.prefix}${value}`}
                       value={this.state.value && this.state.value[1] ? this.state.value : [this.props.item.min, this.props.item.max]}
                       onChange={(val) => this.handleChange(val)}/>
            </div>
        );
    }
}